import { Button } from "antd";
import { useEffect, useState } from "react";
import WithPermission from "../components/misc/WithPermission";
import ManageService from "../components/services/ManageService";
import ServiceList from "../components/services/ServiceList";
import { Service } from "../entities/interfaces/service";
import ServiceService from "../services/services.service";
import { Link } from "react-router";
import { useStore } from "../context/StoreContext";
import { saveAsFile } from "../utils/helpers";
import toast from "react-hot-toast";

const Services = () => {
  const { selectedStore } = useStore();
  const [services, setServices] = useState<Service[]>([]);
  const [manageServiceModal, setManageServiceModal] = useState(false);
  const [selected, setSelected] = useState<Service | undefined>();

  useEffect(() => {
    getServices();
  }, []);

  const getServices = async () => {
    const res = await ServiceService.list({});
    if (!res?.success) return;
    setServices(res.data);
  };

  const openManageServiceModal = () => {
    setManageServiceModal(true);
  };

  const closeManageServiceModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageServiceModal(false);
  };

  const exportServices = async () => {
    try {
      const res = await ServiceService.exportServices();
      saveAsFile(res, `Services Export.csv`, "text/csv;charset=utf-8");
    } catch (err) {
      toast.error("Error downloading services export");
    }
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Services</h1>
          <p>Manage your organisation services</p>
          {selectedStore ? (
            <h2 className="text-base mt-3 text-gray-500">
              Showing services for the store:{" "}
              <span className="text-black font-semibold">
                {selectedStore.name}
              </span>
            </h2>
          ) : (
            <h2 className="text-base mt-3 text-gray-500">
              Showing all the services
            </h2>
          )}
        </div>
        <WithPermission permission="create:services">
          <div className="flex  gap-3">
            <Button onClick={exportServices}>Export Services</Button>
            <Link to={"/services/create"}>
              <Button type="primary">Create Service</Button>
            </Link>
          </div>
        </WithPermission>
        <ManageService
          open={manageServiceModal}
          onChange={getServices}
          onClose={closeManageServiceModal}
          selected={selected}
        />
      </div>
      <ServiceList
        services={services}
        onSelect={(data) => {
          openManageServiceModal();
          setSelected(data);
        }}
      />
    </div>
  );
};

export default Services;
